<template>
    <div style="overflow:hidden;">
        <img src="@/assets/image/success/bei.png" alt="交卷成功">

        <div v-if="score">
            <div class="score">您的得分：{{score}}</div>
            <div class="tip">此分数仅仅是示意，不能反映真实的作答情况</div>
        </div>
        <!-- <a href="http://www.zhuofan.net/product/miitj?change=4" class="download" target="_blank">下载使用手册</a> -->
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
            score:"100",
        }
    },
    created(){
        
        if(this.$route.query.score){

            this.score = this.$route.query.score == 'false'?false:this.$route.query.score;
            this.score = this.score === 0?'100':this.score;
        }else{
            this.score = false;
        }
        this.$store.commit("user",{},"111");
        this.$store.commit("project",{});
        this.$store.commit("exam",{});
        this.$store.commit("answer",{});
        this.$store.commit("config",{});

        

    },
    methods: {
    },
}
</script>
<style lang='scss' scoped>
img{display:block; margin:100px auto 30px;}
.download{    font-size: 13px;    border: 1px solid #e7661b;    color: #e7661b;    padding: 5px 10px;    display: block;    width: 100px;    text-align:center;    margin: 20px auto;    border-radius: 3px;}
.score{color: red;    text-align: center;    font-size: 30px;    margin-bottom: 10px;}
.tip{text-align: center;    color: #701919;}
</style>